import { clientFetch } from '@/sanity/lib/client'
import { urlForImage } from '@/sanity/lib/image'
import { useMediaQuery } from '@mui/material'
import { getFileAsset } from '@sanity/asset-utils'
import { useEffect, useRef } from 'react'

const Video = ({ imagePlaceholder, video }) => {
  const base = 'w-full h-full object-cover top-0 left-0'

  const isMobile = useMediaQuery('(max-width:767px)')

  const posterSrc = isMobile
    ? urlForImage(imagePlaceholder.mobile).url()
    : urlForImage(imagePlaceholder.desktop).url()

  const videoSrc = isMobile
    ? video
      ? getFileAsset(video.mobile, clientFetch.config()).url
      : ''
    : video
    ? getFileAsset(video.desktop, clientFetch.config()).url
    : ''

  const videoRef = useRef(null)

  useEffect(() => {
    videoRef?.current?.play()
  }, [videoSrc])

  return (
    <video
      ref={videoRef}
      playsInline
      muted
      loop
      defaultmuted="true"
      poster={posterSrc}
      className={base}
    >
      <source src={videoSrc} type="video/mp4" />
    </video>
  )
}

export default Video
